import React, { useEffect, useState } from 'react';
import './WalletPage.css';
import { BACKEND_URL } from '../../services/Helper';
import { toast } from 'react-toastify';
import AOS from 'aos';
import 'aos/dist/aos.css';

const WalletPage = () => {
  const [coupons, setCoupons] = useState([]);
  const [loading, setLoading] = useState(true);
  const [copiedCode, setCopiedCode] = useState(null);

  useEffect(() => { AOS.init({ duration: 800 }); }, []);

  useEffect(() => {
    const token = localStorage.getItem('nearbeusertoken');
    if (!token) { setLoading(false); return; }

    const fetchWallet = async () => {
      try {
        const res = await fetch(`${BACKEND_URL}/nearbe/coupon/wallet`, {
          headers: { Authorization: token },
        });
        const data = await res.json();
        if (res.ok) setCoupons(data.coupons || []);
        else toast.error('Failed to load wallet');
      } catch {
        toast.error('Something went wrong!');
      } finally {
        setLoading(false);
      }
    };
    fetchWallet();
  }, []);

  const copyCode = (code) => {
    navigator.clipboard.writeText(code);
    setCopiedCode(code);
    setTimeout(() => setCopiedCode(null), 2000);
  };

  const getStatus = (coupon) => {
    if (coupon.isUsed) return { label: 'Used', color: '#888', bg: 'rgba(136,136,136,0.1)' };
    if (new Date() > new Date(coupon.expiresAt)) return { label: 'Expired', color: '#ff4545', bg: 'rgba(255,69,69,0.1)' };
    return { label: 'Active', color: '#69f0ae', bg: 'rgba(105,240,174,0.1)' };
  };

  if (loading) return <p className="wallet-msg">⏳ Loading wallet...</p>;
  if (!localStorage.getItem('nearbeusertoken'))
    return <p className="wallet-msg">🔒 Please login to view your wallet</p>;

  return (
    <div className="wallet-container" data-aos="fade-up">
      <div className="wallet-header">
        <h2>🏦 My Wallet</h2>
        <p>{coupons.length} coupon{coupons.length !== 1 ? 's' : ''} claimed</p>
      </div>

      {coupons.length === 0 ? (
        <div className="wallet-empty">
          <div className="wallet-empty-icon">🎟️</div>
          <p>No coupons yet. Go to Offers and claim your first one!</p>
        </div>
      ) : (
        <div className="wallet-grid">
          {coupons.map((coupon) => {
            const status = getStatus(coupon);
            const isActive = status.label === 'Active';
            return (
              <div
                key={coupon._id}
                className={`wallet-card ${!isActive ? 'wallet-card-dim' : ''}`}
              >
                <div className="wallet-card-top">
                  <div className="wallet-discount">{coupon.discountApplied}% OFF</div>
                  <span
                    className="wallet-status-badge"
                    style={{ color: status.color, background: status.bg, borderColor: status.color }}
                  >
                    {status.label}
                  </span>
                </div>

                <div className="wallet-card-body">
                  <p className="wallet-shop">{coupon.shop?.shopName || '—'}</p>
                  <p className="wallet-offer">{coupon.offer?.title || '—'}</p>
                  {coupon.feedbackProvided && (
                    <span className="wallet-feedback-badge">⭐ Feedback bonus applied</span>
                  )}
                </div>

                <div className="wallet-code-row">
                  <span className="wallet-code">{coupon.couponCode}</span>
                  {isActive && (
                    <button
                      className="wallet-copy-btn"
                      onClick={() => copyCode(coupon.couponCode)}
                    >
                      {copiedCode === coupon.couponCode ? '✓' : '📋'}
                    </button>
                  )}
                </div>

                <div className="wallet-card-footer">
                  <span className="wallet-date">
                    Claimed: {new Date(coupon.claimedAt).toLocaleDateString('en-IN')}
                  </span>
                  <span className="wallet-expiry">
                    Expires: {new Date(coupon.expiresAt).toLocaleString('en-IN', { dateStyle: 'short', timeStyle: 'short' })}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default WalletPage;
